import { RoundBadge } from '@peacecover/component';

interface SceneCategoryTagListProps {
  tags: string[];
  summary: string;
  className?: string;
}

const PreviewHeaderItem = ({ tags, summary, className }: SceneCategoryTagListProps) => {
  return (
    <section className={`px-[24px] flex flex-col gap-[16px] ${className}`}>
      <div className="flex items-center gap-[8px]">
        {tags.map((tag) => (
          <RoundBadge key={tag} className="bg-[rgba(255,255,255,0.20)] text-pure-white">
            {tag}
          </RoundBadge>
        ))}
      </div>
      <p
        className="text-[16px] leading-[28px] text-pure-white"
        style={{ fontFamily: '"Noto Serif KR", ui-serif, Georgia, serif' }}
      >
        {summary}
      </p>
    </section>
  );
};

export default PreviewHeaderItem;
